import { useMemo } from 'react';

import { ArticleQueryVariables } from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/types/grappa.types';
import {
  getArticlePreviewQuery,
  GetArticlePreviewQueryResult,
} from 'components/settings/components/sections/dixaMessenger/views/flow/components/shared/knowledgeBaseLinkPreview/api';
import { useElevioQuery } from 'components/settings/components/sections/dixaMessenger/views/flow/hooks/elevio/useElevioQuery';

type Params = {
  id: string | undefined;
};

type ReturnType = {
  isLoading: boolean;
  data: GetArticlePreviewQueryResult | null;
  isError: boolean;
  error: Error | null;
};

export function usePublicElevioArticle({ id }: Params): ReturnType {
  const variables = useMemo(
    () =>
      !id
        ? undefined
        : ({
            id,
            languageId: 'en',
            pageUrl: window.location.origin,
          } satisfies ArticleQueryVariables),
    [id],
  );

  const result = useElevioQuery<GetArticlePreviewQueryResult>({
    query: getArticlePreviewQuery,
    variables,
  });

  return useMemo(
    () => ({
      isLoading: result.isLoading,
      data: result.data,
      isError: !!result.error,
      error: result.error,
    }),
    [result],
  );
}
